$(document).ready(function() {
    
    // Set random background on login & password pages
    
    var randomLoginBG = [
        'login-bg-1.jpg',
        'login-bg-2.jpg',
        'login-bg-3.jpg',
        'login-bg-4.jpg'
    ];
    
    if(!$('body').hasClass('ng-scope')) {
       
        $('body').css(
            'background-image',
            'url(/img/' + randomLoginBG[Math.floor(Math.random() * randomLoginBG.length)] + ')'
        );
    
    };
    
    $('ul.nav-tabs').on('click', 'li a', function() {
        
        var tab = $(this).attr('href');
        
        $('.tab-content div, ul.nav-tabs li').each(function() {
            $(this).removeClass('active'); 
        });
        
        $(this).parent('li').addClass('active');
        $(tab).addClass('active');
        
        return false;
        
    });
    
    $(document).on('click', '.btn-tooltip', function() {
        $('.tooltip').hide(); 
    });
    
    $(document).tooltip({
        selector: '[data-toggle="tooltip"]',
        container: 'body',
        trigger: 'hover'
    });
    
});

// Angular

var app = angular.module('ewebs', ['ngRoute', 'angularUtils.directives.dirPagination', 'angular.filter', 'ngFileUpload', 'ui.sortable', 'ui.bootstrap', 'ngAnimate', 'hc.marked', 'angular-markdown-editor', 'base64'], function($interpolateProvider) {
	$interpolateProvider.startSymbol('<%');
	$interpolateProvider.endSymbol('%>');
});

// HighlightJS
app.config(['markedProvider', function (markedProvider) {
    
    markedProvider.setOptions({
        gfm: true,
        tables: true,
        highlight: function (code, lang) {
            
            if (lang) {
                return hljs.highlight(lang, code, true).value;
            } else {
                return hljs.highlightAuto(code).value;
            }
            
        }
    });
    
}]);

// Routes
app.config(['$routeProvider', '$locationProvider', function($routeProvider, $locationProvider, access) {
    
    $locationProvider.hashPrefix('');
    
    $routeProvider.
     when('/project/:id', {
        templateUrl: function(params) { return 'project-dashboard/' + params.id; },
        controller: 'projectDashboard',
        resolve: {
            "check": function (access, $location) {  
                if(!access.permission()) {
                    //$location.path('/');
                }
            }
        }
    }).
    when('/project/:id/form/:formid', {
        templateUrl: function(params) { return 'project-details/' + params.id + '/form/' + params.formid; },
        controller: 'projects',
        resolve: {
            "check": function (access, $location) {  
                if(!access.permission()) {
                    //$location.path('/');
                }
            }
        }
    }).
    when('/project/:id/form/:formid/edit/:regid', {
        templateUrl: 'registration-details',
        controller: 'projects',
        resolve: {
            "check": function (access, $location) {  
                if(!access.permission()) {
                    //$location.path('/');
                }
            }
        }
    }).
    when('/project/:id/form/:formid/new', {
        templateUrl: 'registration-new',
        controller: 'projects',
        resolve: {
            "check": function (access, $location) {  
                if(!access.permission()) {
                    //$location.path('/');
                }
            }
        }
    }).
    when('/admin/project/:id', {
        templateUrl: function(params) { return 'admin-project/' + params.id; },
        controller: 'adminProject'
    }).
    when('/admin/user/:id', {
        templateUrl: 'admin-user',
        controller: 'adminUser'
    }).
    when('/profile', {
        templateUrl: 'profile',
        controller: 'profile'
    }).
    when('/user/:id', {
        templateUrl: function(params) { return 'user/' + params.id; },
        controller: 'user'
    }).
    when('/project/:id/crm/users', {
        templateUrl: 'crm-users',
        controller: 'crm'
    }).
    when('/project/:id/crm/groups', {
        templateUrl: 'crm-groups',
        controller: 'crm'
    }).
    when('/project/:id/crm/emails', {
        templateUrl: 'crm-emails',
        controller: 'crm'
    }).
    when('/project/:id/crm/emails/new', {
        templateUrl: 'crm-emails-new',
        controller: 'crm'
    }).
    when('/project/:id/crm/emails/edit/:emailid', {
        templateUrl: 'crm-emails-edit',
        controller: 'crmEditEmail'
    }).
    when('/project/:id/crm/reports', {
        templateUrl: 'crm-reports',
        controller: 'crm'
    }).
    when('/project/:id/crm/reports/:reportid', {
        templateUrl: 'crm-report-details',
        controller: 'crm'
    }).
    when('/', {
        templateUrl: 'dashboard',
        controller: 'dashboardController'
    }).
    otherwise({
        redirectTo: '/'
    });
    
}]);

/*
 * Filters
 */

/*
 * Factories
 */

app.factory('access', ['$route', '$location', '$http', '$rootScope', function($route, $location, $http, $rootScope) {
    
    var obj = {},
        access,
        id;
    
    $http.get('/api/project').then( function(response) {
            
        obj.data = response.data;

    });
    
    $rootScope.$on('updateNav', function () {
        
        $http.get('/api/project').then( function(response) {
            
            obj.data = response.data;

        });
        
    });
    
    obj.checkPermission = function(id) {
        
        access = false;
        
        angular.forEach(obj.data, function(item, i) {
           
            if(item.id == id)
                access = true;
            
        });
        
        return access;
        
    }
    
    obj.permission = function() {
        
        id = $route.current.pathParams.id;
        
        return obj.checkPermission(id);
        
    }
    
    return obj;
    
}]);

app.factory('alertService', ['$timeout', function ($timeout) {
   
    let alertService = {};
    
    alertService.alerts = [];
    
    alertService.add = function (type, msg) {
        
        let id = Math.floor((Math.random() * 1000) + 1);
        
        alertService.alerts.push({ id: id, type: type, msg: msg });
        
        $timeout(function () {
            
            angular.forEach (alertService.alerts, function (item, i) {
               
                if(item.id == id)
                    alertService.alerts.splice(i, 1);
                
            });

        }, 6000);
        
    }
    
    alertService.closeAlert = function (index) {
        alertService.alerts.splice(index, 1);
    }
    
    return alertService;
    
}]);

/*
 * Directives 
 */

app.directive('ngConfirm', ['$uibModal', function ($uibModal) {
    
    return {
        restrict: 'A',
        scope: {
            ngConfirmHeader: '@',
            ngConfirmMessage: '@',
            ngConfirmAlert: '@',
            ngConfirm: '&'
        },
        link: function (scope, element) {
            
            element.bind('click', function () {
                
                var modalInstance = $uibModal.open({
                    template: '<div class="block margin-bottom-0"><div class="block-header bg-gray-lighter"><button type="button" class="close" ng-click="cancel()">&times;</button><h3 class="block-title"><% confirmHeader %></h3></div><div class="block-content p-rel"><p><% confirmMessage %></p></div><div class="block-content bg-gray-lighter"><div class="form-group margin-bottom-15"><button type="button" class="btn btn-primary btn-submit btn-sm d-inline-block margin-right-10" ng-click="ok()">Yes</button><button type="button" class="btn btn-danger btn-sm d-inline-block" ng-click="cancel()">No</button></div></div></div>',
                    controller: 'ModalConfirmCtrl',
                    size: '',
                    windowClass: '',
                    animation: true,
                    resolve: {
                        confirmClick: function () {
                            return scope.ngConfirm;
                        },
                        confirmHeader: function () {
                            return scope.ngConfirmHeader;
                        },
                        confirmMessage: function () {
                            return scope.ngConfirmMessage;
                        },
                        confirmAlert: function () {
                            return scope.ngConfirmAlert;
                        }
                    }
                });
                
            });
        }
    }
    
}])
.controller('ModalConfirmCtrl', ['$scope', '$uibModalInstance', 'confirmClick', 'confirmHeader', 'confirmMessage', 'confirmAlert', 'alertService', function ($scope, $uibModalInstance, confirmClick, confirmHeader, confirmMessage, confirmAlert, alertService) {
    
    $scope.confirmHeader = confirmHeader;
    $scope.confirmMessage = confirmMessage;
    $scope.confirmAlert = confirmAlert;
    
    function closeModal() {
        
        $uibModalInstance.dismiss('cancel');
        
    }

    $scope.ok = function () {
        
        confirmClick();
        alertService.add('success', $scope.confirmAlert);
        closeModal();
        
    }

    $scope.cancel = function () {
        
        closeModal();
        
    }
        
}]);

app.directive('alertDisplay', ['alertService', function (alertService) {
    
    return {
        
        restrict: 'AE',
        template: '<div ng-repeat="alert in vm.alerts" class="col-md-12 alert alert-<% alert.type %> alert-dismissable"><button ng-click="vm.closeAlert($index)" type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button><h3 class="font-light uc-first" ng-if="alert.type == \'success\'">Success</h3><h3 class="font-light uc-first" ng-if="alert.type != \'success\'">Error</h3><p><% alert.msg %></p></div>',
        controller: function () {
            
            let vm = this;
            
            vm.alertService = alertService;
            
            vm.alerts = vm.alertService.alerts;
            
            vm.closeAlert = function (index) {
                vm.alertService.closeAlert(index);
            }
            
        },
        controllerAs: 'vm'
        
    }
    
}]);

/*
 * Controllers
 */

app.controller('ewebsController', ['$scope', '$rootScope', '$location', 'access', function($scope, $rootScope, $location, access) {
    
    // In bytes
    $scope.maxFileSize = 2048 * 1024;
    
    $scope.$back = function() { 
        window.history.back();
    };
    
    $scope.isCurrentPath = function (path) {
        return $location.path() == path;
    };
    
    $scope.closeModal = function () {
        
        $('body').removeClass('modal-open').find('.modal-backdrop').remove();
        
    }
    
    $scope.editProject = function (project_id) {
        
        $location.path('/admin/project/' + project_id);
        
    }
    
    $scope.randomPassword = function (length = 15) {
        
        let chars   = '!@#$%ABCDEFGHIJKLMNOP1234567890',
            string  = '';
        
        for (let x = 0; x < length; x++) {
            
            let i = Math.floor(Math.random() * chars.length);
            
            string += chars.charAt(i);
            
        }
        
        return string;
        
    }
    
    $scope.formatBytes = function (bytes, decimals) {
        
        if(bytes === 0)
            return '0 Bytes';
        
        let k       = 1024,
            dm      = decimals || 2,
            sizes   = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
            i       = Math.floor(Math.log(bytes) / Math.log(k));
        
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
        
    }
    
}]);

// Admin
app.controller('adminProject', ['$scope', '$route', '$routeParams', '$location', '$http', '$uibModal', '$uibModalStack', 'Upload', '$filter', 'alertService', '$rootScope', function ($scope, $route, $routeParams, $location, $http, $uibModal, $uibModalStack, Upload, $filter, alertService, $rootScope) {
    
    $scope.project = [];
    $scope.project_metadata = [];
    $scope.project_forms = [];
    $scope.project_users = [];
    
    $scope.users = [];
    
    $scope.form_values = [];
    
    $scope.form = {};
    $scope.new_form = {};
    $scope.new_field = {};
    $scope.new_field.key_values = [];
    $scope.edit_field = {};
    $scope.edit_field.key_values = [];
    $scope.invite_user = {};
    $scope.edit_project = {};
    
    $scope.projectUserList = false;
    
    $scope.routeParams = {};
    $scope.routeParams.id = $route.current.params.id;
 
	$scope.init = function() {
        
        $scope.project_elements = [];
        
        $http.get('/api/users').
        
		then( function (response) {
			$scope.users = response.data;
		});
        
		$http.get('/api/project/' + $route.current.params.id).
        
		then( function (response) {
			$scope.project = response.data[0];
		});
        
        $http.get('/api/project_metadata/' + $route.current.params.id).
        
		then( function (response) {
			$scope.project_metadata = response.data;
		});
        
        $http.get('/api/element_type/').
        
		then( function (response) {
            $scope.element_types = response.data;
		});
        
		$http.get('/api/project_forms/' + $route.current.params.id).
        
		then( function (response) {
               
            angular.forEach(response.data, function(form, i) {

                $http.get('/api/form_elements/form/' + form.id).then( function (response) {
                    
                    let elements = $filter('orderBy')(response.data, 'field_order');
                    
                    angular.forEach(elements, function(item, i) {
                        
                        if(item.values)
                            item.values = JSON.parse(item.values);

                    });
                    
                    $scope.project_elements.push(elements);
                    
                });

            });
            
            $scope.project_forms = response.data;
            
		});
        
        $http.get('/api/project_users/project_id/' + $route.current.params.id).
        
		then( function (response) {
            
            angular.forEach($scope.users, function(item, id) {
               
                angular.forEach(response.data, function(user, i) {
                   
                    if(user.user_id == item.id)
                        user.data = item;
                    
                });
                
            });
            
			$scope.project_users = response.data;
            
		});
        
	}
    
    $scope.sortableOptions = {
        handle: '> .moveable',
        axis: 'y',
        'ui-floating': true
    };
    
    $scope.sort = function (form_id, arr) {
        
        let postData = arr;
        
        $http.put('/api/form_elements/order/' + form_id, {
            data: postData
        });
        
    }
    
    $scope.findProjectLogo = function(project_id) {
        
        var img;
        
        angular.forEach($scope.project_metadata, function(item, id) {
           
            if(item.project_id == project_id && item.meta_key == 'logo') {
                img = item.meta_data;
                return;
            } 
            
        });
        
        return img;
        
    }
    
    $scope.userAlreadyInProject = function (id) {
        
        if($scope.project_users.length > 0) {
            
            var found = $scope.project_users.some( function(item) {
            
                return item.user_id === id;

            });

            return found;
            
        }
        
    }
    
    $scope.addUserToProject = function (id) {
        
        $http.post('/api/project_users/add/', {
            
            project_id: $route.current.params.id,
            user_id: id
            
        }).
        
        then( function (response) {
            alertService.add('success', 'User added to project!');
            $scope.init();
        });
        
    }
    
    $scope.removeUserFromProject = function (id) {
        
        $http.delete('/api/project_users/' + id).
        
        then( function (response) {
            alertService.add('success', 'User removed from project!');
			$scope.init();
        });
        
    }
    
    $scope.updateProjectLogo = function(file) {
        
        if(file.size >= $scope.maxFileSize) {

            alertService.add('danger', 'Image is too big! Max file size is ' + $scope.formatBytes($scope.maxFileSize));
            
            file = null;
            
            return false;
            
        }
        
        Upload.upload({
            
            url: 'api/upload',
            data: {
                file: file,
                prefix: 'logo',
                type: 'image',
                project_id: $scope.routeParams.id
            }
            
        }).then(function (resp) {
            
            alertService.add('success', 'Logo updated!');
            $scope.init();
            //console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ', resp.data);
            
        }, function (resp) {
            
            console.log('Error', resp.data);
            //console.log('Error status: ' + resp.status);
            
        }, function (evt) {
            
            var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
            //console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
            
        });
        
    }
    
    $scope.notFoundInObj = function(data, key) {
        
        var notFound = true;
        
        data.forEach(function(item, index) {
            
            if(item.meta_key == key)
                notFound = false;
            
        });
        
        return notFound;
        
        
    }
    
    $scope.updateProjectMetadata = function() {
        
        var postData = [];
        
        $scope.loading = true;
        
        angular.forEach($scope.form, function(value, key) {
            
            postData.push({meta_key: key, meta_data: value});
            
        });
        
        postData = angular.toJson(postData);
        
        $http.put('/api/project_metadata/project_id/' + $route.current.params.id, {
            data: postData
        }).then( function (response) {
            
            $scope.loading = false;
            
            alertService.add('success', 'Metadata updated!');
            
            $('#projectMetadata').modal('hide');
                
            $scope.closeModal();
            
            $scope.init();
            
		});
        
    }
    
    $scope.elementType = function (element_id) {
        
        let type;
        
        angular.forEach($scope.element_types, function(item, id) {
            
            if(element_id == item.id)
                type = item.type;
            
        });
        
        return type;
        
    }
    
    $scope.editElement = function (element_id) {
        
        $scope.fields = {};
        
        $http.get('/api/form_elements/' + element_id).then( function (response) {
                    
            angular.forEach(response.data, function(item, i) {

                if(item.values) {
                    
                    item.values = JSON.parse(item.values);
                    
                }

            });

            $scope.element = response.data;
            
            let modalInstance = $uibModal.open({
                templateUrl: 'edit-field',
                size: '',
                windowClass: '',
                scope: $scope,
                animation: true
            });

        });
        
    }
    
    $scope.editField = function (id) {
        
        let values  = [],
            type    = $scope.edit_field.type,
            name    = $scope.edit_field.name,
            label   = $scope.edit_field.label,
            key_val = $scope.edit_field.key_values;
        
        if(!type) {
            
            alertService.add('danger', 'You forgot to select a field type!');
            
            return false;
            
        }
        
        if(!name) {
            
            alertService.add('danger', 'You forgot to fill in a field name!');
            
            return false;
            
        }
        
        if(!label) {
            
            alertService.add('danger', 'You forgot to fill in a field label!');
            
            return false;
            
        }
        
        if(type == 1 || type == 4 || type == 5) {
            
            if(key_val.length == 0) {
                
                alertService.add('danger', 'You forgot to fill in a key and value!');

                return false;
                
            }
            
        }
        
        if(key_val.length > 0) {
            
            angular.forEach(key_val, function(value, key) {
            
                values.push(value);

            });

            values = angular.toJson(values);
            
        } else {
            
            values = '';
            
        }
        
        $http.put('/api/form_elements/' + id, {
            element_id: type,
            name: name,
            label: label,
            values: values
        }).then( function (response) {
            
            $scope.edit_field = {};
            $scope.edit_field.key_values = [];
            
            alertService.add('success', 'Field updated!');
            
            $scope.init();
                
            $scope.closeModal();
            $uibModalStack.dismissAll();
            
		});
        
    }
    
    $scope.removeElement = function (element_id) {
        
        $http.delete('/api/form_elements/' + element_id)
        
        .then( function (response) {
            alertService.add('success', 'Field removed!');
            $scope.init();
        });
        
    }
    
    $scope.addKeyValueField = function (form_id, edit = false) {
        
        if(edit) {
            
            if(!$scope.element[0].values)
                $scope.element[0].values = [];
            
            $scope.edit_field.key_values.push({ key: '', value: '' });
            $scope.element[0].values.push({ key: '', value: '' });
            
        } else {
            
            $scope.new_field.key_values.push({ key: '', value: '' });
            
        }
        
    }
    
    $scope.import = function (type, file, form_id, edit = false) {
        
        let allowed = ['csv', 'xls', 'json'];
        
        if(!allowed.includes(type))
            return false;
        
        if(file.size >= $scope.maxFileSize) {

            alertService.add('danger', 'File is too big! Max file size is ' + $scope.formatBytes($scope.maxFileSize));
            
            file = null;
            
            return false;
            
        }
        
        Upload.upload({
            
            url: 'api/upload',
            data: {
                file: file,
                type: type,
                form_id: form_id
            }
            
        }).then(function (resp) {
            
            if(edit) {
                
                angular.forEach (resp.data.data, function (item) {
                    
                    $scope.edit_field.key_values.push({ key: item.key, value: item.value });
                    $scope.element[0].values.push({ key: item.key, value: item.value });
                    
                });
                
            } else {
                
                angular.forEach (resp.data.data, function (item) {
                    
                    $scope.new_field.key_values.push({ key: item.key, value: item.value });
                    
                });
                
            }
            
            //console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ', resp.data);
            
        });
        
        return false;
        
    }
    
    $scope.removeKeyValue = function (id, edit = false) {
        
        if(edit) {
            
            $scope.edit_field.key_values.splice(id, 1);
            $scope.element[0].values.splice(id, 1);
            
        } else {
            
            $scope.new_field.key_values.splice(id, 1);
            
        }
        
    }
    
    $scope.addNewField = function (form_id) {
        
        let values  = [],
            type    = $scope.new_field.type,
            name    = $scope.new_field.name,
            label   = $scope.new_field.label,
            key_val = $scope.new_field.key_values;

        if(!type) {
            
            alertService.add('danger', 'You forgot to select a field type!');
            
            return false;
            
        }
        
        if(!name) {
            
            alertService.add('danger', 'You forgot to fill in a field name!');
            
            return false;
            
        }
        
        if(!label) {
            
            alertService.add('danger', 'You forgot to fill in a field label!');
            
            return false;
            
        }
        
        if(type == 1 || type == 4 || type == 5) {
            
            if(key_val.length == 0) {
                
                alertService.add('danger', 'You forgot to fill in a key and value!');

                return false;
                
            }
            
        }
        
        if($scope.new_field.key_values.length > 0) {
            
            angular.forEach($scope.new_field.key_values, function(value, key) {
            
                values.push(value);

            });

            values = angular.toJson(values);
            
        } else {
            
            values = '';
            
        }
        
        $http.post('/api/form_elements', {
            form_id: form_id,
            element_id: type,
            name: name,
            label: label,
            values: values
        }).then( function (response) {
            
            alertService.add('success', 'Field ' + name + ' created!');
            
            $scope.new_field = {};
            $scope.new_field.key_values = [];
            
            $scope.init();
                
            $scope.closeModal();
            
		});
        
    }
    
    $scope.addNewForm = function (project_id) {
        
        if(!$scope.new_form.name) {
            
            alertService.add('danger', 'You forgot to fill in a form name!');
            
            return false;
            
        }
        
        $http.post('/api/project_forms', {
            project_id: project_id,
            form_name: $scope.new_form.name
        }).then( function (response) {
            
            alertService.add('success', 'Form ' + $scope.new_form.name + ' created!');
            
            $scope.new_form = {};
            
            $scope.init();
            
            $rootScope.$emit('updateNav', {});
            
            $('#newForm').modal('hide');
                
            $scope.closeModal();
            
		});
        
    }
    
    $scope.hideForm = function (form_id) {
        
        $http.put('/api/project_forms/' + form_id, {
            hide: '1'
        }).then( function (response) {
            
            $rootScope.$emit('updateNav', {});
           
            alertService.add('success', 'Form ' + response.data.form_name + ' is now hidden!');
            $scope.init();
            
        });
        
    }
    
    $scope.showForm = function (form_id) {
        
        $http.put('/api/project_forms/' + form_id, {
            hide: '0'
        }).then( function (response) {
            
            $rootScope.$emit('updateNav', {});
           
            alertService.add('success', 'Form ' + response.data.form_name + ' is now visible!');
            $scope.init();
            
        });
        
    }
    
    $scope.inviteUser = function () {
        
        let project_id  = $route.current.params.id,
            email       = $scope.invite_user.email;
        
        if(!email) {
            
            alertService.add('danger', 'You forgot to fill in an email!');
            
            return false;
            
        }
        
        $http.post('/api/checkEmail', {
            project_id: project_id,
            email: email
        }).then( function (response) {
            
            alertService.add('success', 'User added to project!');
            
            $scope.invite_user = {};
            
            $scope.init();
            
		}, function (response) {
            
            if(response.data == 'user_exists')
                alertService.add('danger', 'User already exists in project!');
            
            if(response.data.email)
                alertService.add('danger', response.data.email[0]);
            
		});
        
        return false;
        
    }
    
    $scope.editProject = function (project_id) {
        
        $scope.fields = {};

        $http.get('/api/project/' + $route.current.params.id).then( function (response) {
            
            $scope.element = response.data;
            
            let modalInstance = $uibModal.open({
                templateUrl: 'edit-project',
                size: '',
                windowClass: '',
                scope: $scope,
                animation: true
            });

        });
        
    }
    
    $scope.editProjectSubmit = function(id) {
        
        let project_name = $scope.edit_project.project_name;
        
        if(!project_name) {
            
            alertService.add('danger', 'You forgot to fill in a project name!');
            
            return false;
            
        }
        
        $http.put('/api/project/' + id, {
            project_name: project_name
        }).then( function (response) {
            
            $scope.edit_project = {};
            
            alertService.add('success', 'Project updated!');
            
            $scope.init();
            
            $rootScope.$emit('updateNav', {});
                
            $scope.closeModal();
            $uibModalStack.dismissAll();
            
		});
        
    }
    
    $scope.init();
    
}]);


// Projects
app.controller('projects', ['$scope', '$route', '$routeParams', '$location', '$http', '$rootScope', function ($scope, $route, $routeParams, $location, $http, $rootScope) {
    
    $scope.projects = [];
    $scope.project_forms = [];
 
	$scope.init = function() {
        
		$http.get('/api/project').
        
		then( function (response) {
			$scope.projects = response.data;
		});
        
		$http.get('/api/project_forms').
        
		then( function (response) {
			$scope.project_forms = response.data;
		});
        
	}
    
    $scope.newRegistration = function() {
        $location.path('/project/' + $route.current.params.id + '/form/' + $route.current.params.formid + '/new');
    }
    
    $scope.$on('$routeChangeSuccess', function() {

        $scope.routeParams = {};
        $scope.routeParams.project_id = $routeParams.id;
        $scope.routeParams.form_id = $routeParams.formid;

        $scope.route = {};
        $scope.route.controller = $route.current.controller;
        $scope.route.loadedTemplateUrl = $route.current.loadedTemplateUrl;
        
    });
    
    $scope.showTotal = function(data, trashbin, dividebytwo) {
        
        var count = 0;
        
        angular.forEach(data, function(item, i) {
           
            if(item.trashbin == trashbin)
                count = count+ +1;
            
        });
        
        return count;
        
    }
    
    $rootScope.$on('updateNav', function () {
       
        $scope.init();
        
    });
    
    $scope.init();

}]);

app.filter('trashbin', function() {
    
    return function(items, trashbin) {
        
        var data = [];
        
        angular.forEach(items, function(item, i) {
           
            if(item.trashbin == trashbin) {
                data.push(item);
                return;
            }
            
        });
        
        return data;
        
    }
    
});

app.controller('projectTable', ['$scope', '$route', '$routeParams', '$location', '$http', '$window', 'alertService', function ($scope, $route, $routeParams, $location, $http, $window, alertService) {
    
    $scope.elements = [];
    $scope.values = [];
    
    $scope.currentProject = [];
    
    // Duplicates
    $scope.duplicateNormal = [];
    $scope.duplicateTrashbin = [];
    
    $scope.view = 0;
    
    $scope.checkedDuplicate = false;
    
    $scope.search = '';
    
    // Pagination
    $scope.currentPage = 1;
    $scope.pageSize = 10;
    
    $scope.routeParams = {};
    $scope.routeParams.project_id = $route.current.params.id;
    $scope.routeParams.form_id = $route.current.params.formid;
 
	$scope.init = function() {
        
		$http.get('/api/form_elements/form/' + $scope.routeParams.form_id).
        
		then( function (response) {
			$scope.elements = response.data;
		});
        
        $http.get('/api/form_values/form/' + $scope.routeParams.form_id).
        
		then( function (response) {
            
            response.data.forEach(function(item, index) {
                
                var json = JSON.parse(item.data);
                item.json = json;
                
                $scope.values.push(item);
                
            });
            
		});
        
        $http.get('/api/form_values/current/' + $scope.routeParams.form_id + '/' + $scope.routeParams.project_id).
        
		then( function (response) {
            
            $scope.currentProject.push(response.data);
            
		});
        
	}
    
    $scope.editRegistration = function(id) {
        $location.path('/project/' + $route.current.params.id + '/form/' + $route.current.params.formid + '/edit/' + id);
    }
    
    $scope.moveRegistration = function(id, trashbin) {
        
        $http.put('/api/form_values/id/' + id, {
            trashbin: trashbin
        }).then( function (response) {
            
            $scope.values = [];
            $scope.loading = false;
            
            $http.get('/api/form_values/form/' + $scope.routeParams.form_id).
        
            then( function (response) {
                
                alertService.add('success', 'Registration moved!');

                response.data.forEach(function(item, index) {

                    var json = JSON.parse(item.data);
                    item.json = json;

                    $scope.values.push(item);

                });

            })
            
		});
        
    }
    
    $scope.changeview = function(view) {
        
        $scope.view = view;
        
        if($scope.checkedDuplicate == true && $scope.view == 0) {
            $scope.values = $scope.duplicateNormal;
        }
        
        if($scope.checkedDuplicate == true && $scope.view == 1) {
            $scope.values = $scope.duplicateTrashbin;
        }
        
    }
    
    $scope.duplicateList = function(checked) {
        
        $scope.values = [];
        $scope.duplicateNormal = [];
        $scope.duplicateTrashbin = [];
        
        if(!checked) {
            
            $scope.checkedDuplicate = true;
        
            $http.get('/api/form_values/duplicates/' + $scope.routeParams.form_id).

            then( function (response) {

                response.data['normal'].forEach(function(item, index) {
                    
                    var json = JSON.parse(item.data);
                    item.json = json;

                    $scope.duplicateNormal.push(item);

                });
                
                response.data['trashbin'].forEach(function(item, index) {
                    
                    var json = JSON.parse(item.data);
                    item.json = json;

                    $scope.duplicateTrashbin.push(item);

                });

            });
            
            $scope.changeview($scope.view);
            
        }
        
        if(checked) {
            
            $scope.checkedDuplicate = false;
        
            $http.get('/api/form_values/form/' + $scope.routeParams.form_id).
        
            then( function (response) {

                response.data.forEach(function(item, index) {

                    var json = JSON.parse(item.data);
                    item.json = json;

                    $scope.values.push(item);

                });

            })
            
        }
        
    }
    
    $scope.export = function() {
        
        $http.post('/api/form_values/export_form/', {
            form_id: $scope.routeParams.form_id,
            project_id: $scope.routeParams.project_id,
            search: $scope.search
        },
        {
            responseType: 'arraybuffer'
        }). 
            then( function (response) {
                
                var date = new Date().toISOString().substr(0, 10),
                    fileName = $scope.currentProject[0].projectName + ' - ' + $scope.currentProject[0].formName + ' ' + date + '.xls',
            
                    url = $window.URL || $window.webkitURL,
                    result = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
                    fileURL = url.createObjectURL(result),
                
                    a = document.createElement('a');
                
                a.href = fileURL;
                a.target = '_blank';

                a.download = fileName;
                
                document.body.appendChild(a);
            
                a.click();

            });
        
        return false;
        
    }
    
    $scope.exportStatistics = function () {
        
        $http.post('/api/form_values/export_pdf/', {
            form_id: $scope.routeParams.form_id,
            project_id: $scope.routeParams.project_id
        },
        {
            responseType: 'arraybuffer'
        }).then( function (response) {
            
            var date = new Date().toISOString().substr(0, 10),
                fileName = 'Statistics for ' + $scope.currentProject[0].projectName + ' - ' + $scope.currentProject[0].formName + ' ' + date + '.pdf',

                url = $window.URL || $window.webkitURL,
                result = new Blob([response.data], { type: 'application/octet-stream' }),
                fileURL = url.createObjectURL(result),

                a = document.createElement('a');

            a.href = fileURL;
            a.target = '_blank';

            a.download = fileName;

            document.body.appendChild(a);

            a.click();

        });
        
        return false;
        
    }
    
    $scope.$on('$routeChangeSuccess', function() {

        $scope.routeParams = {};
        $scope.routeParams.project_id = $routeParams.id;
        $scope.routeParams.form_id = $routeParams.formid;
        
    });
    
    $scope.init();
    
}])
.directive('setSearchToScope', function($http) {
    
    return {
        
        require: 'ngModel',
        scope: '',
        link: function($scope, element, attr, ngModel) {
            
            $scope.$watch( function() {
                return ngModel.$modelValue; 
            }, function(newValue) {
                $scope.search = newValue;
            });
            
        },
        controller: function($scope, $element, $attrs, $location, $routeParams) {
            
        }
        
    }
    
});;

// Registration information
app.controller('registrationInfo', ['$scope', '$route', '$routeParams', '$location', '$http', 'alertService', function ($scope, $route, $routeParams, $location, $http, alertService) {
    
    var putData = [];
    
    $scope.loading = false;
    
    $scope.element_types = [];
    $scope.elements = [];
    $scope.registration = [];
    $scope.values = [];
    
    $scope.form = {};
    $scope.sendEmail = false;
    
    $scope.routeParams = {};
    $scope.routeParams.form_id = $route.current.params.formid;
    $scope.routeParams.id = $route.current.params.regid;
    $scope.routeParams.project_id = $route.current.params.id;
    
    $scope.init = function() {
        
        $scope.loading = true;
        
        $http.get('/api/element_type/').
        
		then( function (response) {

			$scope.element_types = response.data;
            
		});
        
        $http.get('/api/form_elements/form/' + $scope.routeParams.form_id).
        
		then( function (response) {
            
            response.data.forEach(function(item, index) {
                
                if(item.values) {
                    
                    var vals = JSON.parse(item.values);
                    item.key_values = vals;
                    
                }
                
                $scope.elements.push(item);
                
            });
            
		});
        
        $http.get('/api/form_values/id/' + $scope.routeParams.id).
        
		then( function (response) {
            
            $scope.registration = response.data[0];
            
            response.data.forEach(function(item, index) {
                
                var json = JSON.parse(item.data);
                item.json = json;
                
                $scope.values.push(item);
                
            });
            
            $scope.values = $scope.values[0].json;
            $scope.loading = false;
            
		});
        
	}
    
    $scope.notFoundInObj = function(data, element_id) {
        
        var notFound = true;
        
        data.forEach(function(item, index) {
            
            if(item.element_id == element_id)
                notFound = false;
            
        });
        
        return notFound;
        
        
    }
    
    $scope.updateRegistration = function() {
        
        putData = [];
        
        $scope.loading = true;
        
        angular.forEach($scope.form, function(value, key) {
            
            putData.push({ element_id: key, value: value });
            
        });
        
        putData = angular.toJson(putData);
        
        $http.put('/api/form_values/id/' + $scope.routeParams.id, {
            data: putData
        }).then( function (response) {
            $scope.loading = false;
            
            $scope.registration = [];
            $scope.values = [];
            
            $http.get('/api/form_values/id/' + $scope.routeParams.id).
        
            then( function (response) {

                $scope.registration = response.data[0];

                response.data.forEach(function(item, index) {

                    var json = JSON.parse(item.data);
                    item.json = json;

                    $scope.values.push(item);

                });

                $scope.values = $scope.values[0].json;
                $scope.loading = false;
                
                alertService.add('success', 'Registration has been updated!');
                
                if($scope.sendEmail)
                    $scope.sendConfirmation();
                
                $scope.sendEmail = false;

            });
            
		});
        
    }
    
    $scope.moveRegistration = function() {
        
        var trashbin,
            text;
        
        if($scope.registration.trashbin == 0) {
            trashbin = 'moveToTrashbin';
            text = 'trashbin';
        }
        
        if($scope.registration.trashbin == 1) {
            trashbin = 'moveToRegistration';
            text = 'registrations';
        }
        
        $http.put('/api/form_values/id/' + $scope.routeParams.id, {
            trashbin: trashbin
        }).then( function (response) {
            
            $scope.registration = [];
            $scope.values = [];
            
            $http.get('/api/form_values/id/' + $scope.routeParams.id).
        
            then( function (response) {

                $scope.registration = response.data[0];

                response.data.forEach(function(item, index) {

                    var json = JSON.parse(item.data);
                    item.json = json;

                    $scope.values.push(item);

                });

                $scope.values = $scope.values[0].json;
                
                alertService.add('success', 'Registration has been moved to ' + text + '!');

            });
            
		});
        
    }
    
    $scope.sendConfirmation = function () {
        
        $http.post('/email-confirmation', {
            id: $scope.routeParams.id,
            form_id: $scope.routeParams.form_id,
            project_id: $scope.routeParams.project_id
        }).then( function (response) {
            
            alertService.add('success', 'Confirmation e-mail sent to ' + response.data + '!');
            
        }, function (response) {
            
            if(response.data == 'not_sent')
                alertService.add('danger', 'E-mail was not sent.');
            
            if(response.data == 'not_found')
                alertService.add('danger', 'No valid e-mail found.');
            
        });
        
    }
    
    $scope.init();
    
}]);

// New registration
app.controller('newRegistration', ['$scope', '$route', '$routeParams', '$location', '$http', 'alertService', function ($scope, $route, $routeParams, $location, $http, alertService) {
    
    var postData;
    
    $scope.loading = false;
    
    $scope.element_types = [];
    $scope.elements = [];
    
    $scope.form = {};
    
    $scope.routeParams = {};
    $scope.routeParams.form_id = $route.current.params.formid;
    
    $scope.init = function() {
        
        $scope.loading = true;
        
        $http.get('/api/element_type/').
        
		then( function (response) {

			$scope.element_types = response.data;
            
		});
        
        $http.get('/api/form_elements/form/' + $scope.routeParams.form_id).
        
		then( function (response) {
            
            response.data.forEach(function(item, index) {
                
                if(item.values) {
                    
                    var vals = JSON.parse(item.values);
                    item.key_values = vals;
                    
                }
                
                $scope.elements.push(item);
                
            });
            
		});
        
	}
    
    $scope.createRegistration = function() {
        
        postData = [];
        
        $scope.loading = true;
        
        angular.forEach($scope.form, function(value, key) {
            
            postData.push({ element_id: key, value: value });
            
        });
        
        postData = angular.toJson(postData);
        
        $http.post('/api/form_values/add', {
            form_id: $route.current.params.formid,
            data: postData
        }).then( function (response) {
            
            $scope.loading = false;
            
            alertService.add('success', 'Registration has been created!');
            
            $scope.form = {};
            
		});
        
    }
    
    $scope.init();
    
}]);

// Dashboard
app.controller('dashboardController', ['$scope', '$location', '$http', 'alertService', '$rootScope', '$uibModal', '$uibModalStack', function ($scope, $location, $http, alertService, $rootScope, $uibModal, $uibModalStack) {
    
    $scope.users = [];
    $scope.projects = [];
    $scope.project_metadata = [];
    $scope.project_forms = [];
    $scope.active = false;
    $scope.active_today = {};
    $scope.active_month = {};
    $scope.active_total = {};
    
    $scope.new_project = {};
    $scope.new_user = {};
    $scope.edit_user = {};
 
	$scope.init = function() {
        
        $http.get('/api/users').
        
		then( function (response) {
			$scope.users = response.data;
		});
        
		$http.get('/api/project').
        
		then( function (response) {
			$scope.projects = response.data;
		});
        
        $http.get('/api/project_metadata').
        
		then( function (response) {
			$scope.project_metadata = response.data;
		});
        
		$http.get('/api/project_forms').
        
		then( function (response) {
			$scope.project_forms = response.data;
		});
        
        $http.get('/api/form_values/active/').
        
		then( function (response) {
            
            $scope.active = true;
            
            $scope.active_today.project = 'N/A';
            $scope.active_today.registrations = 0;
            
            $scope.active_month.project = 'N/A';
            $scope.active_month.registrations = 0;
            
            $scope.active_total.project = 'N/A';
            $scope.active_total.registrations = 0;
            
            let highest = {};
            
            highest.today_total = 0;
            
            highest.today = 0;
            highest.today_project = 'N/A';
            
            highest.month = 0;
            highest.month_project = 'N/A';
            
            highest.total = 0;
            highest.total_project = 'N/A';
            
            angular.forEach(response.data, function(project, id) {          
           
                angular.forEach(project, function(item, id) {
                    
                    if(item.total.today)
                        highest.today_total += item.total.today;
                   
                    if(item.total.today > highest.today) {
                        
                        highest.today = item.total.today;
                        highest.today_project = item.project_name;
                        
                    }
                    
                    if(item.total.month > highest.month) {
                        
                        highest.month = item.total.month;
                        highest.month_project = item.project_name;
                        
                    }
                    
                    if(item.total.total > highest.total) {
                        
                        highest.total = item.total.total;
                        highest.total_project = item.project_name;
                        
                    }
                    
                });

            });
            
            $scope.total_today = highest.today_total;
            
            $scope.active_today.registrations = highest.today;
            $scope.active_today.project = highest.today_project;
            
            $scope.active_month.registrations = highest.month;
            $scope.active_month.project = highest.month_project;
            
            $scope.active_total.registrations = highest.total;
            $scope.active_total.project = highest.total_project;
            
		});
        
	}
    
    $scope.total_registrations = function(when) {
        
        switch (when) {
                
            case 'today':
                return $scope.total_today;
                break;
                
        }
        
    }
    
    $scope.most_active = function(when, type) {
        
        if($scope.active) {
            
            switch (when) {
                
                case 'today':

                    if(type == 'project')
                        return $scope.active_today.project;

                    if(type == 'registrations')
                        return $scope.active_today.registrations;

                    break;
                    
                case 'month':

                    if(type == 'project')
                        return $scope.active_month.project;

                    if(type == 'registrations')
                        return $scope.active_month.registrations;

                    break;
                    
                case 'total':

                    if(type == 'project')
                        return $scope.active_total.project;

                    if(type == 'registrations')
                        return $scope.active_total.registrations;

                    break;

            }
            
        }
        
    }
    
    $scope.openProject = function(project_id) {
        
        $location.path('/project/' + project_id);
        
    }
    
    $scope.editProject = function (project_id) {
        
        $location.path('/admin/project/' + project_id);
        
    }
    
    $scope.openUser = function (user_id) {
        
        $location.path('/user/' + user_id);
        
    }
    
    $scope.editUser = function (user_id) {
        
        $location.path('/admin/user/' + user_id);
        
    }
    
    $scope.findProjectLogo = function(project_id) {
        
        var img;
        
        angular.forEach($scope.project_metadata, function(item, id) {
           
            if(item.project_id == project_id && item.meta_key == 'logo') {
                img = item.meta_data;
                return;
            } 
            
        });
        
        return img;
        
    }
    
    $scope.addNewProject = function () {
        
        let project_name = $scope.new_project.name;
        
        if(!project_name) {
            
            alertService.add('danger', 'You forgot to fill in a project name!');
            
            return false;
            
        }
        
        $http.post('/api/project', {
            project_name: project_name
        }).then( function (response) {
            
            alertService.add('success', 'Project created!');
            
            $scope.new_project = {};
            
            $scope.init();
            
            $('#newProject').modal('hide');
            $scope.closeModal();
            
            $rootScope.$emit('updateNav', {});
            
        });
        
    }
    
    $scope.addNewUser = function () {
        
        let level       = $scope.new_user.level,
            key         = $scope.new_user.key,
            name        = $scope.new_user.name,
            email       = $scope.new_user.email,
            password    = $scope.randomPassword(),
            company     = $scope.new_user.company,
            phonenumber = $scope.new_user.phonenumber,
            bio         = $scope.new_user.bio;
        
        if(!level) {
            
            alertService.add('danger', 'You forgot to select a user level!');
            
            return false;
            
        }
        
        if(!name) {
            
            alertService.add('danger', 'You forgot to fill in a name!');
            
            return false;
            
        }
        
        if(!email) {
            
            alertService.add('danger', 'You forgot to fill in your email!');
            
            return false;
            
        }
        
        $http.post('/createuser', {
            level: level,
            key: key,
            name: name,
            email: email,
            password: password,
            company: company,
            phonenumber: phonenumber,
            bio: bio
        }).then( function (response) {
            
            alertService.add('success', 'User created!');
            
            $scope.new_user = {};
            
            $scope.init();
            
            $('#newUser').modal('hide');
            $scope.closeModal();
            
        }, function (response) {
            
            console.log(response.data);
            
            if(response.data.level)
                alertService.add('danger', response.data.level[0]);
            
            if(response.data.name)
                alertService.add('danger', response.data.name[0]);
                
            if(response.data.email)
                alertService.add('danger', response.data.email[0]);
            
            if(response.data.password)
                alertService.add('danger', response.data.password[0]);
            
        });
        
        return false;
        
    }
    
    $scope.editUser = function (user_id) {
        
        $scope.fields = {};
        $scope.levels = [{
            level: 2,
            label: 'User'
        }, {
            level: 1,
            label: 'Project admin'
        }, {
            level: 0,
            label: 'Super admin'
        }],
        $scope.activated = [{
            activated: 0,
            label: 'No'
        }, {
            activated: 1,
            label: 'Yes'
        }];
        
        $http.get('/api/users/' + user_id).then( function (response) {

            $scope.element = response.data;
            
            let modalInstance = $uibModal.open({
                templateUrl: 'edit-user',
                size: '',
                windowClass: '',
                scope: $scope,
                animation: true
            });

        });
        
    }
    
    $scope.formEditUser = function (user_id) {
        
        let activated   = $scope.edit_user.activated,
            level       = $scope.edit_user.level,
            key         = $scope.edit_user.key,
            name        = $scope.edit_user.name,
            email       = $scope.edit_user.email,
            company     = $scope.edit_user.company,
            phonenumber = $scope.edit_user.phonenumber,
            bio         = $scope.edit_user.bio;
        
        if(activated == null) {
            
            alertService.add('danger', 'You forgot to set activated status!');
            
            return false;
            
        }
        
        if(level == null) {
            
            alertService.add('danger', 'You forgot to select a user level!');
            
            return false;
            
        }
        
        if(!name) {
            
            alertService.add('danger', 'You forgot to fill in a name!');
            
            return false;
            
        }
        
        if(!email) {
            
            alertService.add('danger', 'You forgot to fill in your email!');
            
            return false;
            
        }
        
        console.log(key);
        
        $http.post('/edituser', {
            user_id: user_id,
            activated: activated,
            level: level,
            key: key,
            name: name,
            email: email,
            company: company,
            phonenumber: phonenumber,
            bio: bio
        }).then( function (response) {
            
            alertService.add('success', 'User updated!');
            
            $scope.edit_user = {};
            
            $scope.init();
            
            $scope.closeModal();
            $uibModalStack.dismissAll();
            
        }, function (response) {
            
            if(response.data.activated)
                alertService.add('danger', response.data.activated[0]);
            
            if(response.data.level)
                alertService.add('danger', response.data.level[0]);
            
            if(response.data.name)
                alertService.add('danger', response.data.name[0]);
                
            if(response.data.email)
                alertService.add('danger', response.data.email[0]);
            
        });
        
        return false;
        
    }
    
    $scope.deleteUser = function (user_id) {
        
        $http.delete('/api/users/' + user_id)
        .then( function (response) {
            
            $scope.init();
            
        }, function (response) {
            
            alertService.add('danger', response.data);
            
        });
        
        return false;
        
    }
    
    $scope.init();

}]);

// Project dashboard
app.controller('projectDashboard', ['$scope', '$location', '$route', '$http', '$window', 'Upload', 'alertService', function ($scope, $location, $route, $http, $window, Upload, alertService) {
    
    $scope.project = [];
    $scope.project_metadata = [];
    $scope.project_forms = [];
    $scope.project_users = [];
    
    $scope.users = [];
    
    $scope.form_values = [];
    
    $scope.form = {};
    
    $scope.projectUserList = false;
    
    $scope.routeParams = {};
    $scope.routeParams.id = $route.current.params.id;
 
	$scope.init = function() {
        
        $http.get('/api/users').
        
		then( function (response) {
			$scope.users = response.data;
		});
        
		$http.get('/api/project/' + $route.current.params.id).
        
		then( function (response) {
			$scope.project = response.data[0];
		});
        
        $http.get('/api/project_metadata/' + $route.current.params.id).
        
		then( function (response) {
			$scope.project_metadata = response.data;
		});
        
		$http.get('/api/project_forms/' + $route.current.params.id).
        
		then( function (response) {
			$scope.project_forms = response.data;
		});
        
        $http.get('/api/project_users/project_id/' + $route.current.params.id).
        
		then( function (response) {
            
            angular.forEach($scope.users, function(item, id) {
               
                angular.forEach(response.data, function(user, i) {
                   
                    if(user.user_id == item.id)
                        user.data = item;
                    
                });
                
            });
            
			$scope.project_users = response.data;
            
		});
        
	}
    
    $scope.findProjectLogo = function(project_id) {
        
        var img;
        
        angular.forEach($scope.project_metadata, function(item, id) {
           
            if(item.project_id == project_id && item.meta_key == 'logo') {
                img = item.meta_data;
                return;
            } 
            
        });
        
        return img;
        
    }
    
    $scope.userAlreadyInProject = function (id) {
        
        if($scope.project_users.length > 0) {
            
            var found = $scope.project_users.some( function(item) {
            
                return item.user_id === id;

            });

            return found;
            
        }
        
    }
    
    $scope.addUserToProject = function (id) {
        
        $http.post('/api/project_users/add/', {
            
            project_id: $route.current.params.id,
            user_id: id
            
        }).
        
        then( function (response) {
            alertService.add('success', 'User added to project!');
            $scope.init();
        });
        
    }
    
    $scope.removeUserFromProject = function (id) {
        
        $http.delete('/api/project_users/' + id).
        
        then( function (response) {
            alertService.add('success', 'User removed from project!');
			$scope.init();
        });
        
    }
    
    $scope.updateProjectLogo = function(file) {
        
        if(file.size >= $scope.maxFileSize) {

            alertService.add('danger', 'Image is too big! Max file size is ' + $scope.formatBytes($scope.maxFileSize));
            
            file = null;
            
            return false;
            
        }
        
        Upload.upload({
            
            url: 'api/upload',
            data: {
                file: file,
                prefix: 'logo',
                type: 'image',
                project_id: $scope.routeParams.id
            }
            
        }).then(function (resp) {
            
            alertService.add('success', 'Logo updated!');
            $scope.init();
            //console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ', resp.data);
            
        }, function (resp) {
            
            console.log('Error', resp.data);
            //console.log('Error status: ' + resp.status);
            
        }, function (evt) {
            
            var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
            //console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
            
        });
        
    }
    
    $scope.notFoundInObj = function(data, key) {
        
        var notFound = true;
        
        data.forEach(function(item, index) {
            
            if(item.meta_key == key)
                notFound = false;
            
        });
        
        return notFound;
        
        
    }
    
    $scope.updateProjectMetadata = function() {
        
        var postData = [];
        
        $scope.loading = true;
        
        angular.forEach($scope.form, function(value, key) {
            
            postData.push({meta_key: key, meta_data: value});
            
        });
        
        postData = angular.toJson(postData);
        
        $http.put('/api/project_metadata/project_id/' + $route.current.params.id, {
            data: postData
        }).then( function (response) {
            
            $scope.loading = false;
            
            alertService.add('success', 'Metadata updated!');
            
            $('#projectMetadata').modal('hide');
                
            $scope.closeModal();
            
            $scope.init();
            
		});
        
    }
    
    $scope.exportAll = function() {
        
        $http.post('/api/form_values/export_all/', {
            project_id: $scope.routeParams.id
        },
        {
            responseType: 'arraybuffer'
        }). 
            then( function (response) {
                
                var date = new Date().toISOString().substr(0, 10),
                    fileName = $scope.project.project_name + ' ' + date + '.xls',
            
                    url = $window.URL || $window.webkitURL,
                    result = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
                    fileURL = url.createObjectURL(result),
                
                    a = document.createElement('a');
                
                a.href = fileURL;
                a.target = '_blank';

                a.download = fileName;
                
                document.body.appendChild(a);
            
                a.click();

            });
        
        return false;
        
    }
    
    $scope.inviteUser = function () {
        
        let project_id  = $route.current.params.id,
            email       = $scope.invite_user.email;
        
        if(!email) {
            
            alertService.add('danger', 'You forgot to fill in an email!');
            
            return false;
            
        }
        
        $http.post('/api/checkEmail', {
            project_id: project_id,
            email: email
        }).then( function (response) {
            
            console.log(response.data);
            
            alertService.add('success', 'User added to project!');
            
            $scope.invite_user = {};
            
            $scope.init();
            
		}, function (response) {
            
            console.log(response.data);
            
            if(response.data == 'user_exists')
                alertService.add('danger', 'User already exists in project!');
            
            if(response.data.email)
                alertService.add('danger', response.data.email[0]);
            
		});
        
        return false;
        
    }
    
    $scope.init();

}])
.directive('getTotalRegistrations', function($http) {
    
    return {
        
        scope: {
            form: '@formId'
        },
        link: function(scope, element, attr) {
            
            $http.get('/api/form_values/count/' + scope.form).
        
            then( function (response) {
                scope.project = response.data;
            });
            
        },
        template: '<small>{{ project }}</small>'
        
    }
    
});

app.controller('profile', ['$scope', '$location', '$http', 'alertService', function ($scope, $location, $http, alertService) {
    
    $scope.form = {};
    $scope.user = {};
    
    $scope.init = function () {
        
        $http.get('api/profile').then( function (response) {
            
            $scope.form.name = response.data.info.name;
            $scope.form.email = response.data.info.email;
            
            $scope.form.company = response.data.meta.company;
            $scope.form.phonenumber = response.data.meta.phonenumber;
            $scope.form.bio = response.data.meta.bio;
            
        });
        
    }
    
    $scope.updateProfile = function () {
        
        let name                    = $scope.form.name,
            email                   = $scope.form.email,
            company                 = $scope.form.company,
            phonenumber             = $scope.form.phonenumber,
            bio                     = $scope.form.bio,
            new_password            = $scope.form.new_password,
            password_confirmation   = $scope.form.password_confirmation,
            current_password        = $scope.form.current_password;
        
        if(!name) {
            
            alertService.add('danger', 'You forgot to fill in your name!');
            
            return false;
            
        }
        
        if(!email) {
            
            alertService.add('danger', 'You forgot to fill in your email!');
            
            return false;
            
        }
        
        if(new_password || password_confirmation) {
            
            if(new_password && !password_confirmation || password_confirmation && !new_password) {
                
                alertService.add('danger', 'You forgot to confirm your password!');
                
                return false;
                
            }
            
            if(new_password && password_confirmation) {
                
                if(new_password != password_confirmation) {
                    
                    alertService.add('danger', 'Your passwords do not match!');
                
                    return false;
                    
                }
                
            }
            
        }
        
        if(!current_password) {
            
            alertService.add('danger', 'You need to fill in your current password to make changes!');
            
            return false;
            
        }
        
        // Password check if no errors
        $http.post('/passwordcheck', {
            password: current_password
        }).then( function (response) {
            
            $http.post('/profile', {
                name: name,
                email: email,
                company: company,
                phonenumber: phonenumber,
                bio: bio,
                new_password: new_password,
                new_password_confirmation: password_confirmation,
                current_password: current_password
            }).then( function (response) {
                
                alertService.add('success', 'Profile updated!');
                
                $scope.form.new_password = '';
                $scope.form.password_confirmation = '';
                $scope.form.current_password = '';
                
            }, function (response) {
                
                if(response.data.name)
                    alertService.add('danger', response.data.name[0]);
                
                if(response.data.email)
                    alertService.add('danger', response.data.email[0]);
                    
                if(response.data.new_password)
                    alertService.add('danger', response.data.new_password[0]);
                
            });
            
        }, function (response) {
            
            alertService.add('danger', 'Wrong password!');
            
            return false;
            
        });
        
        return false;
        
    }
    
    $scope.init();
    
}]);

app.controller('user', ['$scope', '$location', '$http', 'alertService', '$route', function ($scope, $location, $http, alertService, $route) {
    
    
    
}]);

app.controller('crm', ['$scope', '$location', '$http', 'alertService', '$route', '$routeParams', '$uibModal', '$uibModalStack', 'Upload', 'filterFilter', function ($scope, $location, $http, alertService, $route, $routeParams, $uibModal, $uibModalStack, Upload, filterFilter) {
    
    $scope.project              = [];
    $scope.crm_users            = [];
    $scope.crm_groups           = [];
    $scope.crm_group_relations  = [];
    $scope.emails               = [];
    
    $scope.new_user             = {};
    $scope.new_group            = {};
    
    // Emails
    $scope.new_email            = {};
    $scope.new_email.background = '#ffffff';
    $scope.new_email.color      = '#646464';
    $scope.new_email.sender     = 'noreply@ewebs.se';
    
    // Pagination
    $scope.currentPage          = 1;
    $scope.pageSize             = 25;
 
	$scope.init = function() {
        
        $scope.q = '';
        
		$http.get('/api/project/' + $route.current.params.id).
        
		then( function (response) {
			$scope.project = response.data[0];
		});
        
        $http.get('/api/crm/project/' + $route.current.params.id).
        
		then( function (response) {
            
            angular.forEach(response.data.users, function(user, i) {
               
                user.groups = [];
                user.checked = false;
                
            });
            
            angular.forEach(response.data.groups, function(group, i) {
               
                group.checked = false;
                
            });
            
            $scope.crm_users                = response.data.users;
            $scope.crm_groups               = response.data.groups;
            $scope.crm_group_relations      = response.data.group_relations;
            $scope.crm_emails               = response.data.emails;
            
            angular.forEach(response.data.group_relations, function(obj, i) {
                
                angular.forEach($scope.crm_users, function(user, index) {
                   
                    if(obj.user_id == user.user_id)
                        user.groups.push(obj.name);
                    
                });
                
            });
            
		});
        
	}
    
    /*
     * Users
     */
    
    $scope.addNewUser = function () {
        
        let first_name              = $scope.new_user.first_name,
            last_name               = $scope.new_user.last_name,
            email                   = $scope.new_user.email,
            group                   = $scope.new_user.group;
        
        if(!email) {
            
            alertService.add('danger', 'You forgot to fill in your email!');
            
            return false;
            
        }
            
        $http.post('api/crm/addUser', {
            project_id: $route.current.params.id,
            first_name: first_name,
            last_name: last_name,
            email: email,
            group: group
        }).then( function (response) {

            alertService.add('success', 'User added!');

            $('#addUser').modal('hide');
                
            $scope.closeModal();
            
            $scope.init();

        }, function (response) {
            
            if(response.data == 'user_exists')
                alertService.add('danger', 'User already exists in project!');
            
            if(response.data.email)
                alertService.add('danger', response.data.email[0]);

        });
        
        return false;
        
    }
    
    $scope.editUser = function (user_id) {
        
        $scope.fields = {};
        
        $http.get('/api/crm/user/' + user_id).then( function (response) {
            
            angular.forEach(response.data.users, function(user, i) {
               
                user.groups = [];
                
            });
            
            $scope.edit_user                = response.data.users;
            $scope.edit_group_relations     = response.data.group_relations;
            
            angular.forEach(response.data.group_relations, function(obj, i) {
                
                angular.forEach($scope.edit_user, function(user, index) {
                   
                    if(obj.user_id == user.user_id)
                        user.groups.push(obj.id);
                    
                });
                
            });
            
            let modalInstance = $uibModal.open({
                templateUrl: 'edit-crm-user',
                size: '',
                windowClass: '',
                scope: $scope,
                animation: true
            });

        });
        
    }
    
    $scope.editCRMUser = function (user_id) {
        
        let first_name              = $scope.edit_user.first_name,
            last_name               = $scope.edit_user.last_name,
            email                   = $scope.edit_user.email,
            group                   = $scope.edit_user.group;
        
        if(!email) {
            
            alertService.add('danger', 'You forgot to fill in your email!');
            
            return false;
            
        }
            
        $http.post('api/crm/editUser', {
            id: user_id,
            project_id: $route.current.params.id,
            first_name: first_name,
            last_name: last_name,
            email: email,
            group: group
        }).then( function (response) {

            alertService.add('success', 'User updated!');

            $scope.edit_user = {};
            
            $scope.closeModal();
            $uibModalStack.dismissAll();
            
            $scope.init();

        }, function (response) {
            
            if(response.data == 'user_exists')
                alertService.add('danger', 'User already exists!');
            
            if(response.data == 'not_exists')
                alertService.add('danger', 'User does not exist!');
            
            if(response.data.email)
                alertService.add('danger', response.data.email[0]);

        });
        
        return false;
        
    }
    
    $scope.deleteUser = function (user_id) {
        
        $http.delete('/api/crm/user/' + user_id).
        
        then( function (response) {
            
            // Clear checked arr
            $scope.clearToggleAllCrmUsers();
            
			$scope.init();
            
        }, function (response) {
            
            console.log(response.data);

        });
        
    }
    
    $scope.removeUsersFromList = function () {
        
        $http.post('api/crm/userList/remove', {
            list: $scope.crm_users
        }).then( function (response) {
            
            // Clear checked arr
            $scope.clearToggleAllCrmUsers();
            
            $scope.init();

        }, function (response) {
            
            console.log(response.data);

        });
        
        return false;
        
    }
    
    $scope.addListToGroup = function (group_id) {
        
        $http.post('api/crm/groupList/add', {
            group_id: group_id,
            list: $scope.crm_users
        }).then( function (response) {

            alertService.add('success', 'Users added to group!');
            
            // Clear checked arr
            $scope.clearToggleAllCrmUsers();
            
            $scope.init();

        }, function (response) {
            
            console.log(response.data);

        });
        
        return false;
        
    }
    
    $scope.removeListFromGroup = function (group_id) {
        
        $http.post('api/crm/groupList/remove', {
            group_id: group_id,
            project_id: $route.current.params.id,
            list: $scope.crm_users
        }).then( function (response) {

            alertService.add('success', 'Users removed from group!');
            
            // Clear checked arr
            $scope.clearToggleAllCrmUsers();
            
            $scope.init();

        }, function (response) {
            
            console.log(response.data);

        });
        
        return false;
        
    }
    
    $scope.import = function (file) {
        
        if(file.size >= $scope.maxFileSize) {

            alertService.add('danger', 'Image is too big! Max file size is ' + $scope.formatBytes($scope.maxFileSize));
            
            file = null;
            
            return false;
            
        }
        
        Upload.upload({
            
            url: 'api/upload',
            data: {
                file: file,
                type: 'crm_xls',
                project_id: $route.current.params.id
            }
            
        }).then(function (resp) {
            
            alertService.add('success', 'Users imported!');
            
            if(resp.data.data) {
                
                angular.forEach(resp.data.data, function (item) {
                   
                    alertService.add('danger', item);
                    
                });
                
            }
            
            // Clear checked arr
            $scope.clearToggleAllCrmUsers();
            
            $scope.init();
            
        });
        
        return false;
        
    }
    
    $scope.clearToggleAllCrmUsers = function () {
        
        $scope.crm_users_allChecked = false;
        
        $scope.init();
        
        angular.forEach($scope.crm_users, function (user) {
           
            user.checked = false;
            
        });
        
    }
    
    $scope.toggleAllCrmUsers = function () {
        
        let status = $scope.crm_users_allChecked;
        
        if($scope.q)
            $scope.crm_users = filterFilter($scope.crm_users, $scope.q);
        
        angular.forEach($scope.crm_users, function (user) {
           
            user.checked = status;
            
        });
        
    }
    
    $scope.checkIfGroupInArr = function (arr, value) {
        
        if(!arr)
            return '';
        
        if(arr.indexOf(value) !== -1)
            return value.toString();
        
        return '';
        
    }
    
    /*
     * Groups
     */
    
    $scope.createNewGroup = function () {
        
        let name = $scope.new_group.name;
        
        if(!name) {
            
            alertService.add('danger', 'You forgot to fill in a name!');
            
            return false;
            
        }
            
        $http.post('api/crm/createGroup', {
            project_id: $route.current.params.id,
            name: name
        }).then( function (response) {

            alertService.add('success', 'Group created!');

            $('#createGroup').modal('hide');
                
            $scope.closeModal();
            
            $scope.init();

        }, function (response) {
            
            if(response.data == 'group_exists')
                alertService.add('danger', 'Group already exists in project!');

        });
        
        return false;
        
    }
    
    $scope.editGroup = function (id) {
        
        $scope.fields = {};
        
        $http.get('/api/crm/group/' + id).then( function (response) {
            
            $scope.edit_group = response.data;
            
            let modalInstance = $uibModal.open({
                templateUrl: 'edit-crm-group',
                size: '',
                windowClass: '',
                scope: $scope,
                animation: true
            });

        });
        
    }
    
    $scope.editCRMGroup = function (id) {
        
        let name = $scope.edit_group.name;
        
        if(!name) {
            
            alertService.add('danger', 'You forgot to fill in a name!');
            
            return false;
            
        }
            
        $http.post('api/crm/editGroup', {
            id: id,
            project_id: $route.current.params.id,
            name: name
        }).then( function (response) {

            alertService.add('success', 'Group updated!');

            $scope.edit_group = {};
            
            $scope.closeModal();
            $uibModalStack.dismissAll();
            
            $scope.init();

        }, function (response) {
            
            if(response.data == 'group_exists')
                alertService.add('danger', 'Group already exists!');
            
            if(response.data == 'not_exists')
                alertService.add('danger', 'Group does not exist!');

        });
        
        return false;
        
    }
    
    $scope.deleteGroup = function (id) {
        
        $http.delete('/api/crm/group/' + id).
        
        then( function (response) {
            
			$scope.init();
            
        }, function (response) {
            
            console.log(response.data);

        });
        
    }
    
    /*
     * E-mails
     */
    
    $scope.createNewEmail = function () {
        
        let title       = $scope.new_email.title,
            background  = $scope.new_email.background,
            color       = $scope.new_email.color,
            image       = $scope.new_email.image,
            subject     = $scope.new_email.subject,
            sender      = $scope.new_email.sender,
            content     = $scope.new_email.content;
        
        if(!title) {
            
            alertService.add('danger', 'You forgot to fill in a title!');
            
            return false;
            
        }
        
        if(!background) {
            
            alertService.add('danger', 'You forgot to fill in a background color!');
            
            return false;
            
        }
        
        if(!color) {
            
            alertService.add('danger', 'You forgot to fill in a color!');
            
            return false;
        
        }
        
        if(!subject) {
            
            alertService.add('danger', 'You forgot to fill in a subject!');
            
            return false;
            
        }
        
        if(!sender) {
            
            alertService.add('danger', 'You forgot to fill in a sender!');
            
            return false;
            
        }
        
        if(!content) {
            
            alertService.add('danger', 'You forgot to fill in any content!');
            
            return false;
            
        }
        
        $http.post('api/crm/createEmail', {
            project_id: $route.current.params.id,
            title: title,
            background: background,
            color: color,
            image: image,
            subject: subject,
            sender: sender,
            content: content
        }).then( function (response) {

            alertService.add('success', 'E-mail created!');

            $scope.new_email            = {};
            $scope.new_email.background = '#ffffff';
            $scope.new_email.color      = '#646464';
            $scope.new_email.sender     = 'noreply@ewebs.se';
            
            $scope.init();

        }, function (response) {
            
            angular.forEach( response.data, function (item) {
               
                alertService.add('danger', item[0]);
                
            });

        });
        
        return false;
        
    }
    
    $scope.editEmail = function (id) {
        
        $location.path('/project/' + $route.current.params.id + '/crm/emails/edit/' + id);
        
    }
    
    $scope.deleteEmail = function (id) {
        
        $http.delete('/api/crm/email/' + id).
        
        then( function (response) {
            
			$scope.init();
            
        }, function (response) {
            
            console.log(response.data);

        });
        
    }
    
    $scope.setEmailImage = function(file) {
        
        if(file.size >= $scope.maxFileSize) {

            alertService.add('danger', 'Image is too big! Max file size is ' + $scope.formatBytes($scope.maxFileSize));
            
            $scope.new_email.image = null;
            
            return false;
            
        }
        
        Upload.upload({
            
            url: 'api/upload',
            data: {
                file: file,
                prefix: 'email',
                type: 'image',
                project_id: $route.current.params.id
            }
            
        }).then(function (resp) {
            
            $scope.new_email.image = resp.data.data;
            //console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ', resp.data);
            
        }, function (resp) {
            
            console.log('Error', resp.data);
            //console.log('Error status: ' + resp.status);
            
        }, function (evt) {
            
            var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
            //console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
            
        });
        
    }
    
    $scope.openEmailModal = function (id) {
        
        $scope.fields = {};
        $scope.email_id = id;
        
        let modalInstance = $uibModal.open({
            templateUrl: 'send-email',
            size: '',
            windowClass: '',
            scope: $scope,
            animation: true
        });
        
    }
    
    $scope.sendEmail = function (id) {
        
        $http.post('api/crm/sendEmail', {
            id: id,
            project_id: $route.current.params.id,
            groups: $scope.crm_groups
        }).then( function (response) {
            
            console.log(response.data);
            
            alertService.add('success', 'E-mail sent!');
            
            $scope.closeModal();
            $uibModalStack.dismissAll();
            
            $scope.init();

        }, function (response) {
            
            

        });
        
        return false;
        
    }
    
    $scope.init();
    
}]);

app.controller('crmEditEmail', ['$scope', '$location', '$http', 'alertService', '$route', '$routeParams', '$uibModal', '$uibModalStack', 'Upload', 'filterFilter', function ($scope, $location, $http, alertService, $route, $routeParams, $uibModal, $uibModalStack, Upload, filterFilter) {
    
    $scope.edit_email = {};
    
    $scope.edit_email.background    = '#ffffff';
    $scope.edit_email.color         = '#646464';
    $scope.edit_email.sender        = 'noreply@ewebs.se';
    
    $scope.init = function() {
        
        $http.get('/api/crm/email/' + $route.current.params.emailid).
        
		then( function (response) {
			
            $scope.edit_email.title         = response.data[0].title;
            $scope.edit_email.background    = response.data[0].background;
            $scope.edit_email.color         = response.data[0].color;
            $scope.edit_email.image         = response.data[0].image;
            $scope.edit_email.subject       = response.data[0].subject;
            $scope.edit_email.sender        = response.data[0].sender;
            $scope.edit_email.content       = response.data[0].content;
            
		});
        
    }
    
    $scope.editEmail = function () {
        
        let title       = $scope.edit_email.title,
            background  = $scope.edit_email.background,
            color       = $scope.edit_email.color,
            image       = $scope.edit_email.image,
            subject     = $scope.edit_email.subject,
            sender      = $scope.edit_email.sender,
            content     = $scope.edit_email.content;
        
        if(!title) {
            
            alertService.add('danger', 'You forgot to fill in a title!');
            
            return false;
            
        }
        
        if(!background) {
            
            alertService.add('danger', 'You forgot to fill in a background color!');
            
            return false;
            
        }
        
        if(!color) {
            
            alertService.add('danger', 'You forgot to fill in a color!');
            
            return false;
        
        }
        
        if(!subject) {
            
            alertService.add('danger', 'You forgot to fill in a subject!');
            
            return false;
            
        }
        
        if(!sender) {
            
            alertService.add('danger', 'You forgot to fill in a sender!');
            
            return false;
            
        }
        
        if(!content) {
            
            alertService.add('danger', 'You forgot to fill in any content!');
            
            return false;
            
        }
        
        $http.post('api/crm/editEmail', {
            id: $route.current.params.emailid,
            project_id: $route.current.params.id,
            title: title,
            background: background,
            color: color,
            image: image,
            subject: subject,
            sender: sender,
            content: content
        }).then( function (response) {

            alertService.add('success', 'E-mail updated!');

            $scope.edit_email            = {};
            $scope.edit_email.background = '#ffffff';
            $scope.edit_email.color      = '#646464';
            $scope.edit_email.sender     = 'noreply@ewebs.se';
            
            $scope.init();

        }, function (response) {
            
            angular.forEach( response.data, function (item) {
               
                alertService.add('danger', item[0]);
                
            });
            
            if(response.data == 'not_found')
                alertService.add('danger', 'E-mail not found!');

        });
        
        return false;
        
    }
    
    $scope.setEmailImage = function(file) {
        
        if(file.size >= $scope.maxFileSize) {

            alertService.add('danger', 'Image is too big! Max file size is ' + $scope.formatBytes($scope.maxFileSize));
            
            $scope.edit_email.image = null;
            
            return false;
            
        }
        
        Upload.upload({
            
            url: 'api/upload',
            data: {
                file: file,
                prefix: 'email',
                type: 'image',
                project_id: $route.current.params.id
            }
            
        }).then(function (resp) {
            
            $scope.edit_email.image = resp.data.data;
            //console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ', resp.data);
            
        }, function (resp) {
            
            console.log('Error', resp.data);
            //console.log('Error status: ' + resp.status);
            
        }, function (evt) {
            
            var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
            //console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
            
        });
        
    }
    
    $scope.init();
    
}]);

app.controller('crmReports', ['$scope', '$location', '$http', 'alertService', '$route', '$routeParams', '$uibModal', '$uibModalStack', 'Upload', 'filterFilter', function ($scope, $location, $http, alertService, $route, $routeParams, $uibModal, $uibModalStack, Upload, filterFilter) {
    
    $scope.log_data = [];
    $scope.reports  = [];
    $scope.reportid = $route.current.params.reportid;
    
    $scope.init = function() {
        
        $http.get('/email-logs/' + $route.current.params.id).
        
        then( function (response) {
            
            $scope.log_data = response.data;
            
        }, function (response) {
            
            console.log('error', response.data);
        
        });
        
        $http.get('/api/crm/reports/' + $route.current.params.id).
        
        then( function (response) {
            
            $scope.reports = response.data;
            
        }, function (response) {
            
            console.log('error', response.data);
        
        });
        
    }
    
    $scope.showDetails = function (id) {
        
        $location.path('/project/' + $route.current.params.id + '/crm/reports/' + id);
        
    }
    
    $scope.reportTitle = function() {
        
        let title = '';
        
        angular.forEach($scope.reports, function(obj) {
           
            if(obj.id == $route.current.params.reportid)
                title = obj.title;
            
        });
            
        return title;
        
    }
    
    $scope.opened = function(id) {
        
        let count   = 0,
            found   = [];
        
        angular.forEach($scope.log_data, function (item) {
           
            if(item['user-variables'].report_id == id && item.event == 'opened') {
                
                if(found.indexOf(item.recipient) === -1) {
                    
                    found.push(item.recipient);
                    count++;
                    
                }
                
            }
            
        });
        
        return count;
        
    }
    
    $scope.bounced = function(id) {
        
        let count   = 0,
            found   = [];
        
        angular.forEach($scope.log_data, function (item) {
           
            if(item['user-variables'].report_id == id && item.event == 'bounced') {
                
                if(found.indexOf(item.recipient) === -1) {
                    
                    found.push(item.recipient);
                    count++;
                    
                }
                
            }
            
        });
        
        return count;
        
    }
    
    $scope.init();
    
}]);